var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 36,
    viewBox: "0 0 49 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 35.125V21.9375C0.6875 15.6875 2.16667 10.75 5.125 7.125C8.125 3.5 12.4792 1.125 18.1875 0V6.5C13.9375 7.83333 11.0833 10.125 9.625 13.375C8.875 15.0833 8.5625 16.8542 8.6875 18.6875H18.5V35.125H0.6875ZM47.8125 6.5C43.6042 7.79167 40.7708 10.125 39.3125 13.5C38.4792 15.2917 38.1458 17.0208 38.3125 18.6875H48.125V35.125H30.3125V21.9375C30.3125 15.6042 31.8333 10.6458 34.875 7.0625C37.9583 3.47917 42.2708 1.125 47.8125 0V6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.3c5bea966cd84fdbfcb88cdd833fc1e2.svg";
export { ForwardRef as ReactComponent };